const docs = [
  "Passports valid 6+ months — every family member",
  "Apostilled birth & marriage certificates",
  "Custody orders + notarized travel consent letters",
  "Vaccination records & immunization cards",
  "School transcripts & records for each child",
  "International Driving Permit",
  "Prescription copies + 3 months of medications",
  "Printed visa / entry confirmations + return-address card",
];

const tropicalMom = [
  "Breathable cotton & viscose hijabs — double what you think",
  "Lightweight abayas and loose maxi dresses",
  "Compact umbrella + packable rain jacket",
  "Walking sandals that survive monsoon puddles",
  "Natural-fiber slips (humidity is real)",
  "Reef-safe SPF 50 sunscreen",
];
const tropicalKids = [
  "Quick-dry clothes, 10+ sets each — they live outdoors",
  "Swimwear + rash guards",
  "Sandals + one closed walking shoe",
  "Kids' rain ponchos",
  "Mosquito bands + child-safe repellent",
  "One comfort item per child — non-negotiable",
];
const tropicalHealth = [
  "Mosquito repellent (dengue-aware) + after-bite",
  "Electrolyte sachets for the adjustment weeks",
  "Dehumidifier packs for closets",
  "Quick-dry towels + a travel laundry line",
  "Family meds kit: fever, tummy, allergies, antiseptic",
];

const desertMom = [
  "Linen and cotton hijabs — synthetics will suffer",
  "Light abayas + one warm layer for aggressive A/C",
  "Wide-brim hat + UV sunglasses",
  "Comfortable closed shoes for malls, sandals for life",
  "Rich moisturizer + lip balm (desert air)",
  "SPF 50 for face, daily",
];
const desertKids = [
  "Sun hoodies + UV swim shirts",
  "Two hats per child (one will vanish)",
  "Indoor-play shoes — summers are lived inside",
  "Light fleece for over-air-conditioned spaces",
  "Insulated water bottles per child",
  "One comfort item per child — non-negotiable",
];
const desertHealth = [
  "Electrolytes — you will sweat in May–September",
  "Humidifier for bedrooms (A/C dries everything)",
  "Cooling towels for outings",
  "Vitamin D drops — ironic but real indoors",
  "Family meds kit: fever, tummy, allergies, antiseptic",
];

const fourSeasonMom = [
  "A real winter coat + waterproof boots",
  "Layering hijabs: jersey for winter, chiffon for summer",
  "Thermal underlayers (Uniqlo-style)",
  "A proper rain jacket",
  "Summer linens + winter knits — you need both",
  "Good walking shoes for cobblestones and hills",
];
const fourSeasonKids = [
  "Winter coat, boots, hat + gloves per child",
  "Thermal base layers for school days",
  "Rain boots + puddle suits for little ones",
  "Summer shorts + swim gear",
  "Backpack that survives all four seasons",
  "One comfort item per child — non-negotiable",
];
const fourSeasonHealth = [
  "Humidifier for radiator-winter dryness",
  "Vitamin D for gray months",
  "Allergy meds — spring pollen is mighty",
  "Family meds kit: fever, tummy, allergies, antiseptic",
  "Hot water bottles (trust me)",
];

const tropical = (note) => ({ climateNote: note, mom: tropicalMom, kids: tropicalKids, health: tropicalHealth, docs });
const desert = (note) => ({ climateNote: note, mom: desertMom, kids: desertKids, health: desertHealth, docs });
const fourSeason = (note) => ({ climateNote: note, mom: fourSeasonMom, kids: fourSeasonKids, health: fourSeasonHealth, docs });

export const packingData = {
  malaysia: tropical("Tropical & humid, 77–90°F forever. Pack for sweat and sudden rain — winter clothes stay in storage."),
  indonesia: tropical("Tropical islands, wet & dry seasons. Light, modest, quick-dry everything; a good umbrella is a family member."),
  tanzania: {
    ...tropical("Tropical coast. Everything tropical above applies — plus malaria awareness on the coast and in Zanzibar."),
    health: [...tropicalHealth, "Malaria prophylaxis discussion with your doctor before departure", "Mosquito nets for bedrooms (even screened ones)"],
  },
  uae: desert("Desert — 75°F winters, 110°F+ summers. The trick is dressing for sun outside and Arctic A/C inside."),
  saudi: desert("Dry desert heat with genuinely cool winter nights in Riyadh. Abayas are everyday wear — bring your favorites."),
  qatar: desert("Desert Gulf climate. Sun protection outside, cardigans inside — the A/C contrast is the dress code."),
  oman: desert("Hot coast + cooler mountains. Desert basics, plus a light fleece if you'll escape to Jebel Akhdar or Salalah's mist."),
  egypt: desert("Hot dry summers, mild winters needing a real jacket. Dust-friendly colors and washable everything."),
  morocco: fourSeason("Real seasons: mild wet winters, warm dry summers on the coast — Marrakech and Fes run hotter. Layer up."),
  turkiye: fourSeason("True four seasons including Istanbul snow. The only list here where the winter coat is essential, not optional."),
  jordan: fourSeason("Mediterranean-desert: hot dry summers, cold wet winters — Amman gets snow. Pack both extremes."),
};
